/**
 * SuperAdminRoute.jsx - Route guard that requires superadmin role.
 *
 * If the user is authenticated AND has role "superadmin", render children.
 * Otherwise redirect to /dashboard.
 */

import { Navigate } from "react-router-dom";
import { useAuth } from "./apiAuth.jsx";
import ProtectedRoute from "./ProtectedRoute.jsx";

export default function SuperAdminRoute({ children }) {
  const { user } = useAuth();

  return (
    <ProtectedRoute>
      {user?.username === "superadmin" ? children : <Navigate to="/dashboard" replace />}
    </ProtectedRoute>
  );
}
